import { useEffect, type RefObject } from "react"

/**
 * Cierra un elemento (dropdown, menu, popover) cuando se hace click/tap
 * fuera de el. Introducido en Fase B del TODO de UI/UX (menu de usuario
 * en el footer del Sidebar) para no duplicar la logica de
 * "click outside to close" en cada lugar que la necesite.
 */
export function useClickOutside<T extends HTMLElement>(ref: RefObject<T | null>, onOutside: () => void, active = true) {
  useEffect(() => {
    if (!active) return

    function handlePointerDown(event: PointerEvent) {
      if (!ref.current) return
      if (ref.current.contains(event.target as Node)) return
      onOutside()
    }

    document.addEventListener("pointerdown", handlePointerDown)
    return () => document.removeEventListener("pointerdown", handlePointerDown)
  }, [ref, onOutside, active])
}
